import fillCrudMetadataGaps from '../../fillCrudMetadataGaps';
import authorization from '../../util/authorization';
declare module '@niaratech/devcase-crud/dist/types' {
  interface Field<T = any, E = any> {
    custom_onlyMasterServiceAccount?: boolean;
  }
  interface Filter<E = any> {
    custom_onlyMasterServiceAccount?: boolean;
  }
}
export default fillCrudMetadataGaps({
  label: 'Conta de Serviço Master',
  labelPlural: 'Contas de Serviço Master',
  name: 'MasterServiceAccount',
  namePlural: 'MasterServiceAccounts',
  path: '/masterServiceAccounts',
  authorization: authorization('superuser', 'superuser'),
  custom_withAudit: true,
  deletable: false,
  dynamoDB: {
    tableName: 'SpearServiceAccount'
  },
  columnNames: ['id', 'name', 'apiKey', 'tenantName', 'clientName', 'partner', 'enabled', /* usado para montar link no grid */'tenantId', /* usado para montar link no grid */'clientId'],
  fields: [{
    label: 'Id',
    name: 'id',
    type: 'text',
    updatable: false,
    insertable: false,
    id: true,
    renderColumn: false,
    renderForm: false
  }, {
    custom_onlyMasterServiceAccount: true,
    name: 'tenantId',
    label: 'Instalação',
    id: true,
    // necessário para o get funcionar
    required: true,
    updatable: false,
    inputType: 'InputTenant',
    renderColumn: false,
    onEntityChange(oldEntity, newEntity) {
      if (newEntity?.tenantId && oldEntity?.tenantId != newEntity?.tenantId) {
        return {
          ...newEntity,
          clientId: null,
          clientName: null
        };
      }
      return newEntity;
    },
    renderForm: r => r.tenantName
  }, {
    custom_onlyMasterServiceAccount: true,
    name: 'tenantName',
    label: 'Instalação',
    required: true,
    updatable: false,
    renderForm: false
  }, {
    name: 'clientId',
    label: 'Cliente',
    required: true,
    updatable: false,
    renderForm: r => r.clientName,
    renderColumn: false
  }, {
    name: 'clientName',
    label: 'Cliente',
    required: true,
    updatable: false,
    renderForm: false
  }, {
    name: 'name',
    label: 'Nome',
    type: 'text',
    maxLength: 256,
    required: true,
    hint: 'O nome para essa credencial será anexada ao usuário como uma descrição ao lado da chave de acesso.',
    description: 'Nomeie a proposta dessa credencial e onde ela será utilizada. Uma boa descrição te ajudará a alterná-la com segurança mais tarde.'
  }, {
    name: 'apiKey',
    label: 'Chave da API',
    type: 'text',
    required: true,
    insertable: true,
    updatable: false,
    initialize: () => crypto.randomUUID(),
    readOnly: true
  }, {
    name: 'secretKey',
    label: 'Senha da chave de API',
    hint: 'Se você perder ou esquecer a sua chave de acesso secreta, não poderá mais recuperá-la. Ao invés disso, crie uma nova credencial e inative a velha.',
    custom_documentation: 'Não gravamos no banco o secretKey, apenas o hash',
    type: 'text',
    required: true,
    updatable: false,
    render: e => e?.['secretKey'] ? '***' : '-',
    custom_excludeFromAuditValue: true,
    inputType: 'InputServiceAccountPassword'
  }, {
    name: 'enabled',
    label: 'Ativo',
    default: true,
    required: true,
    type: 'boolean'
  }, {
    name: 'usagePlan',
    label: 'Plano de uso',
    type: 'text',
    required: true,
    default: 'LIGHT',
    options: [{
      label: 'Light',
      value: 'LIGHT'
    }, {
      label: 'Premium',
      value: 'PREMIUM'
    }],
    inputType: 'select'
  }, {
    name: 'authorizationMethod',
    label: 'Método de autorização',
    type: 'text',
    default: 'API_CREDENTIALS',
    options: [{
      label: 'Credenciais de API',
      value: 'API_CREDENTIALS'
    }],
    inputType: 'select'
  }, {
    groupName: 'API Niara',
    name: 'partner',
    label: 'Parceiro',
    type: 'text',
    options: [{
      label: 'Argo',
      value: 'ARGO'
    }, {
      label: 'Lemontech',
      value: 'LEMONTECH'
    }, {
      label: 'OpenTrips',
      value: 'OPENTRIPS'
    }, {
      label: 'MAAC Travel',
      value: 'MAAC_TRAVEL'
    }, {
      label: 'Paytrack',
      value: 'PAYTRACK'
    }, {
      label: 'Wooba',
      value: 'WOOBA'
    }, {
      label: 'Oner',
      value: 'ONER'
    }, {
      label: 'Oner (Sem valores Nulos)',
      value: 'ONER_WITHOUT_NULL'
    }, {
      label: 'TechTravel',
      value: 'TECHTRAVEL'
    }, {
      label: 'Cangooroo',
      value: 'CANGOOROO'
    }],
    inputType: 'select',
    required: true
  }, {
    groupName: 'API Niara',
    name: 'permissions',
    label: 'Permissões',
    type: 'textarray',
    options: [{
      label: 'Ping',
      value: 'ping:read'
    }, {
      label: 'Pesquisa de disponibilidade',
      value: 'hotel:search'
    }],
    inputType: 'chips'
  }, {
    groupName: 'API Niara',
    name: 'ratePlanNameOverrideEnabled',
    label: 'Ativar substituição do nome da tarifa',
    hint: 'Configura a API Niara (REST e XML) para alterar o nome da tarifa, colocando o alias da credencial de conteúdo como prefixo',
    type: 'boolean',
    withNullSelector: true,
    default: false,
    required: false
  }, {
    groupName: 'API Niara',
    name: 'locatorOverrideEnabled',
    label: 'Ativar substituição do localizador',
    hint: 'Configura a API Niara (REST e XML) para alterar o localizador, colocando os 8 primeiros caracteres do alias da credencial de conteúdo como prefixo',
    type: 'boolean',
    default: false,
    required: false
  }, {
    name: 'lastUseDate',
    label: 'Última utilização',
    type: 'datetime',
    /** Este campo não é atualizado - e não deveria ser gravado no próprio ServiceServiceAccount, por causa do Audit */
    deprecated: true,
    insertable: false,
    updatable: false,
    custom_excludeFromAuditValue: true,
    render: false,
    readOnly: true
  }, {
    name: 'createDate',
    label: 'Data de criação',
    type: 'datetime',
    readOnly: true,
    insertable: false,
    updatable: false
  }, {
    name: 'isMaster',
    hint: 'true para master',
    type: 'boolean',
    readOnly: true,
    insertable: false,
    updatable: false,
    render: false
  }, {
    name: 'devOHomologOrProd',
    type: 'text',
    readOnly: true,
    insertable: false,
    updatable: false,
    render: false
  }, {
    name: 'ownerId',
    hint: 'Indexado para usar em buscas - tenantId#clientId para serviceAccount, MASTER_xxx#otherTenantId#clientId para masterServiceAccount',
    type: 'text',
    readOnly: true,
    insertable: false,
    updatable: false,
    render: false
  }],
  filter: [{
    field: 'enabled',
    op: 'eq'
  }, {
    field: 'name',
    op: 'contains'
  },
  // {
  //   field: 'tenantId',
  //   op: 'eq',
  //   custom_onlyMasterServiceAccount: true,
  // },
  {
    field: 'clientId',
    op: 'eq'
  }, {
    field: 'ownerId',
    op: 'beginsWith'
  }]
});